import React from 'react';
import { shape, string } from 'prop-types';
var Bing = function Bing(_ref) {
  var tagId = _ref["static"].tagId;
  return React.createElement("script", {
    dangerouslySetInnerHTML: {
      __html: "\n      if(!window.uetq){\n        (function(w,d,t,r,u){var f,n,i;w[u]=w[u]||[],f=function(){var o={ti:\"".concat(tagId, "\", enableAutoSpaTracking: true};o.q=w[u],w[u]=new UET(o),w[u].push(\"pageLoad\")},n=d.createElement(t),n.src=r,n.async=1,n.onload=n.onreadystatechange=function(){var s=this.readyState;s&&s!==\"loaded\"&&s!==\"complete\"||(f(),n.onload=n.onreadystatechange=null)},i=d.getElementsByTagName(t)[0],i.parentNode.insertBefore(n,i)})(window,document,\"script\",\"//bat.bing.com/bat.js\",\"uetq\");\n        }")
    }
  });
};
Bing.ssr = true;
process.env.NODE_ENV !== "production" ? Bing.propTypes = {
  "static": shape({
    id: string.isRequired
  }).isRequired
} : void 0;
export default Bing;